// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"545aecf5","845":"2fd78891"}[chunkId] + ".chunk.js";
};